import React, { useEffect, useRef, useState } from 'react';
import { Button } from '../../../../components/button/button';
import Table from '../../../../components/table/Table';
import SearchInput from '../../../../components/input/SearchInput';
import { Navbar } from '../../../../components/navbar/Navbar';
import BackButton from '../../../../components/button/BackButton';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Label from '../../../../components/title/label';
import Modal from '../../../../components/modals/Modal';
import { BACKEND_URL } from '../../../../constants/constant';


function ConsultationRegisseur() {
  const [recepisse, setRecepisse] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModalError , setShowModalError] = useState(false);
  const [messageError , setMessageError] = useState(false);
  const navigate = useNavigate();
  const UserData = localStorage.getItem("userDataRecette");
  const user = JSON.parse(UserData );
 
  useEffect(() => {
    // Récupérer les données depuis le backend
    axios.get(`${BACKEND_URL}/recette/getAllEnregistrementDeclarationNonPeriodique`)
      .then((response) => setRecepisse(response.data))
      .catch((error) => console.error(error));
  }, []);

  const filteredData = recepisse.filter((item) => {
    const dateCreation = new Date(item.date_creation);
    const isWithinDateRange = startDate && endDate
      ? dateCreation >= new Date(startDate) && dateCreation <= new Date(endDate)
      : true;
    const matchesSearchTerm = item.raison_social && item.raison_social.toLowerCase().includes(searchTerm.toLowerCase()) && item.annulation === false;
    return isWithinDateRange && matchesSearchTerm;
  });

  const headers = ['N° Récepissé', 'RF regisseur', "Raison sociale",  'année',"Impôt","Nature Impôt" , "montant à payer" , "montant à verser" , "Code Banque" , "Mode de payment"];
  const formattedData = filteredData.map(item => [
    item.numero_recepisse, 
    item.nif_regisseur, 
    item.raison_social,
    item.annee, 
    item.numero_impot,
    item.base_impot,
    item.montant_a_payer,
    item.montant_verser,  
    item.code_banque,
    item.type_payment 
  ]);

  const totalMontantVerser = filteredData.reduce((acc, item) => acc + parseFloat(item.montant_verser) || 0, 0);

  const printRef = useRef(null);
  
  // Impression
  const downloadPDF = () => {
    if (printRef.current) {
      const content = printRef.current.innerHTML;
      const originalContent = document.body.innerHTML;

      const printStyle = document.createElement('style');
      printStyle.innerHTML =
        '@media print { body { visibility: hidden; } .print-content { visibility: visible; } }';
      document.head.appendChild(printStyle);

      document.body.innerHTML = `<div class="print-content">${content}</div>`;

      window.print();

      document.head.removeChild(printStyle);
      document.body.innerHTML = originalContent;
      window.location.reload();
    }
  };

  const [DataSelected, setDataSelected] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  
  const handleTableRowClick = (rowIndex) => {
    if (selectedRowIndex === rowIndex) {
      setSelectedRowIndex(null);
      setDataSelected(null);
    } else {
      setSelectedRowIndex(rowIndex);
      const selectedRowData = recepisse[rowIndex];
      setDataSelected(selectedRowData);
    }
  };

  console.log(DataSelected);
  useEffect(() => {
    localStorage.setItem("selectedDataRecetteRegisseur", JSON.stringify(DataSelected));
    console.log(DataSelected);
  }, [DataSelected]);
  

  // Fonction pour gérer l'annulation du paiement sélectionné
  const handleAnnulation = () => {
    if (DataSelected && DataSelected.id_payment) {
      axios.post(`${BACKEND_URL}/recette/annulerPayment`, { id_payment: DataSelected.id_payment , code_operateur : user.code })
        .then(response => {
          console.log(response.data);
          // Mettre à jour la liste des paiements après l'annulation
          setRecepisse(recepisse.filter(payment => payment.id_payment !== DataSelected.id_payment));
          setDataSelected(null);
          setSelectedRowIndex(null);
          setShowModal(true);
        })
        .catch(error => {
          console.error('Failed to annul payment:', error);
         setShowModalError(true);
        });
    } else {
      setMessageError(true);
    }
  };
  const NavbarContent = (
    <div className='flex justify-between'>
      <div className='text-white font-semibold'>
        Visualisation des Paiments par RF REGISSEUR
      </div>
      <div>
        <BackButton to="/NIFRecette"></BackButton>
      </div>
    </div>
  );

  return (
    <div className='bg-[#212122] h-screen w-full'>
      <Navbar content={NavbarContent}></Navbar>
      <div className='flex flex-col p-4'>
        <div className="flex flex-row space-x-4 mb-4">
          <SearchInput onChange={(e) => setSearchTerm(e.target.value)}></SearchInput>
          <input 
            type="date" 
            className="p-2 rounded bg-white text-black" 
            onChange={(e) => setStartDate(e.target.value)} 
            placeholder="Date de début"
          />
          <input 
            type="date" 
            className="p-2 rounded bg-white text-black text-white" 
            onChange={(e) => setEndDate(e.target.value)} 
            placeholder="Date de fin"
          />
          <div className='flex justify-end mt-4 text-white font-bold'>
              Total Montant à Verser: {totalMontantVerser.toLocaleString()} Ar
            </div>
        </div>
        <div className='flex justify-center'>
          <div ref={printRef} className='flex flex-col mt-14 overflow-y-auto w-[1600px]'>
            <Table headers={headers} data={formattedData} onClick={handleTableRowClick} selectedRowIndex={selectedRowIndex}></Table>
            
          </div>
        </div>
        <div className='flex justify-between mt-4'>
          <Button children="Imprimer" onClick={downloadPDF}></Button>
          <Button children="Annuler" onClick={handleAnnulation} ></Button>
          <Button children="Nouveau" onClick={()=> navigate("/EnregistrementDeclarartionRegisseur")}></Button>
          <Button children="Modifier" onClick={()=> navigate("/ModificationNonPeriodique")}></Button>
          <Button children="Rafraîchir" onClick={() => window.location.reload()}></Button>
        </div>
      </div>
      <Modal isOpen={showModal} onClose={()=> setShowModal(false)} className="w-[500px] h-[200px]">
         <div className='flex  justify-center'>
           <div className='flex flex-col mt-14'>
           <Label text="Annulation Fait" className="text-xl"></Label>
<Button children="OK"  onClick={()=> setShowModal(false)} className="mt-4"></Button>
           </div>
         </div>
       </Modal>
       <Modal isOpen={showModalError} onClose={()=> setShowModalError(false)} className="w-[500px] h-[200px]">
         <div className='flex  justify-center'>
           <div className='flex flex-col mt-14'>
           <Label text="Échec de l'annulation du paiement. Veuillez réessayer." className="text-xl"></Label>
<Button children="OK"  onClick={()=> setShowModalError(false)} className="mt-4"></Button>
           </div>
         </div>
       </Modal>
       <Modal isOpen={messageError} onClose={()=> setMessageError(false)} className="w-[500px] h-[200px]">
         <div className='flex  justify-center'>
           <div className='flex flex-col mt-14'>
           <Label text="Veuillez sélectionner un paiement à annuler." className="text-xl"></Label>
<Button children="OK"  onClick={()=> setMessageError(false)} className="mt-4"></Button>
           </div>
         </div>
       </Modal>
       
    </div>
  )
}

export default ConsultationRegisseur;
